import { useFeatureFlags } from "~/contexts/FeatureFlag/FeatureFlag";

import { PremadeListingV1 } from "./PremadeListingV1";
import { PremadeListingV2 } from "./PremadeListingV2";

// PREMADE-REVAMP-CLEANUP: once premadeRevampFlag is fully rolled out, delete PremadeListingV1
// and stylesV1.module.css
// remove this wrapper and rename V2 to PremadeListing
export const PremadeListing = () => {
  const { premadeRevampFlag } = useFeatureFlags();

  return premadeRevampFlag ? <PremadeListingV2 /> : <PremadeListingV1 />;
};
